// Worded odds ("Blue strongly favored") for a sim result, off the CALIBRATED favorite probability: the
// sim's raw win rate run through the backtested fit in simCalibration.json (Platt a, b and the champion's
// incumbency edge), refit on a recent window because the sim keeps changing. The raw % is overconfident at
// the top (in the 300 tournaments to 2026-10-23, a raw 95% won 88% of the time), so the words follow the
// calibrated number, and the exact raw % stays in the Fight View.
import { calibrate } from './simCalibration.js';

// [upper bound of the calibrated favorite probability, word]
export const ODDS_WORDS = [[0.55, 'Toss-up'], [0.65, 'Slight edge'], [0.75, 'Favored'], [0.85, 'Strongly favored'], [Infinity, 'Heavily favored']];

export const wordFor = (favP) => ODDS_WORDS.find(([hi]) => favP < hi)[1];

// res: a runBattles result. params: simCalibration.json. champSide: 'A' | 'B' | null (the Champion's side, if any).
// → { word, fav: 'A' | 'B', p: the calibrated favorite probability, raw: the raw favorite win rate }
export function oddsWords(res, params, { champSide = null } = {}) {
  const rawA = res.n ? res.aWinPct + (res.draws || 0) / res.n / 2 : 0.5; // (a draw counts half to each side)
  const pA = calibrate(params, rawA, { champSide });
  const fav = pA >= 0.5 ? 'A' : 'B', p = Math.max(pA, 1 - pA);
  return { word: wordFor(p), fav, p, raw: fav === 'A' ? rawA : 1 - rawA };
}
